import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import {
  Typography,
  Button,
  TextField,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  CircularProgress,
  IconButton,
  Backdrop,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import SaveOutlinedIcon from "@material-ui/icons/SaveOutlined";
import GetAppIcon from "@material-ui/icons/GetApp";
import PublishIcon from "@material-ui/icons/Publish";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import FileCopyOutlinedIcon from "@material-ui/icons/FileCopyOutlined";
import { appUrl } from "../../../../../../utils/config";
import { formatDate } from '../helpers/dateUtils';
import { MOCK_SCHEDULE_FORM, MOCK_SCHEDULE_FORM_DATA, MOCK_SHIPMENT_IDS } from '../helpers/mockData';
import { buildShipmentOrderCreateXml, buildShipmentOrderResponseXml } from '../helpers/shipmentOrderXml';
import FileViewer from "../../sasl/batch/updateBatch/FileViewer";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const NAVY = "#173072";
const ORANGE = "#EB5E28";

const useStyles = makeStyles(() => ({
  header: {
    backgroundColor: "#F5F9FF",
    position: "relative",
  },
  titleGrid: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1rem",
    backgroundColor: "#F5F9FF",
  },
  head: {
    textAlign: "center",
  },
  closeBtn: {
    display: "flex",
    alignItems: "center",
    position: "absolute",
    top: "12px",
    right: "10px",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
      color: "#FF0000",
    },
  },
  inline: {
    fontSize: "1.5rem",
    display: "inline",
    fontWeight: 600,
    marginBottom: "0.5rem",
  },
  hrLine: {
    backgroundColor: "grey",
    width: "2.5rem",
    height: "3px",
    margin: "inherit",
    marginBottom: "1rem",
    marginTop: "0.25rem",
  },
  root: {
    padding: "12px 24px 40px",
    marginRight:"9rem",
    marginLeft:"10rem",
    backgroundColor: "#FFFFFF",
    minHeight: "100%",
  },
  sectionWrap: {},
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 12,
  },
  editBtn: {
    border: `1px solid #000`,
    color: "#000",
    textTransform: "none",
    borderRadius: 4,
    padding: "2px 12px",
    fontSize: "0.78rem",
    fontWeight: 600,
  },
  cancelBtn: {
    border: "1px solid #9E9E9E",
    color: "#555",
    textTransform: "none",
    borderRadius: 4,
    padding: "2px 12px",
    fontSize: "0.78rem",
    fontWeight: 600,
  },
  fieldLabel: {
    fontSize: "0.85rem",
    color: "#000",
    marginBottom: 2,
    fontWeight: 600,
  },
  fieldValue: {
    fontSize: "0.88rem",
    color: "#222",
    fontWeight: 400,
  },
  divider: {
    border: "0.3px solid #d1d1d1",
    marginTop: "2rem",
    marginBottom: "1rem",
  },
  tableHeadCell: {
    backgroundColor: "#f5f5f5",
    fontWeight: 700,
    fontSize: "0.78rem",
    padding: "8px 10px",
    whiteSpace: "nowrap",
    borderTop: "1px solid #E0E0E0",
    borderBottom: "1px solid #E0E0E0",
    borderLeft: "none",
    borderRight: "none",
  },
  tableBodyCell: {
    padding: "8px 10px",
    fontSize: "0.82rem",
    borderTop: "none",
    borderBottom: "1px solid #E0E0E0",
    borderLeft: "none",
    borderRight: "none",
  },
  content:{
padding: '8px 32px 16px',
marginRight:"8rem",
marginLeft:"10rem"
  },
  uploadBox: {
    border: '1px solid #d0d0d0',
    borderRadius: 4,
    padding: '14px 20px',
    backgroundColor: '#f7f7f7',
    cursor: 'pointer',
    marginTop: 8,
    '&:hover': { borderColor: '#999' },
  },
  submitBtn: {
    backgroundColor: ORANGE,
    color: "#fff",
    borderRadius: 20,
    padding: "10px 40px",
    textTransform: "none",
    fontWeight: 700,
    fontSize: "0.95rem",
    marginTop: 32,
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    "&:hover": { backgroundColor: "#d44e20" },
    "&:disabled": { backgroundColor: "#f5b99d", color: "#fff" },
  },
  successIcon: {
    color: "#277F24",
    fontSize: 64,
    display: "block",
    margin: "0 auto 16px",
  },
  successText: {
    fontWeight: 700,
    textAlign: "center",
    fontSize: "1rem",
  },
  downloadLink: {
    display: "inline-flex",
    alignItems: "center",
    gap: 6,
    color:"#7ac0f8",
    fontSize: "0.85rem",
    cursor: "pointer",
    textDecoration: "underline",
    marginBottom: 8,
  },
  xmlActionBtn: {
    border: "1px solid #9E9E9E",
    color: "#333",
    backgroundColor: "#fff",
    borderRadius: 20,
    textTransform: "none",
    padding: "6px 18px",
    fontSize: "0.8rem",
    fontWeight: 600,
    whiteSpace: "nowrap",
    "&:hover": { backgroundColor: "#f5f5f5", borderColor: "#666" },
  },
  xmlDialogTitle: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottom: "1px solid #E0E0E0",
    padding: "14px 20px",
  },
  xmlPre: {
    margin: 0,
    padding: "16px 20px",
    backgroundColor: "#FAFBFC",
    color: "#1a1a2e",
    fontFamily: 'Consolas, "Courier New", monospace',
    fontSize: "0.8rem",
    lineHeight: 1.55,
    whiteSpace: "pre",
    overflow: "auto",
    maxHeight: "65vh",
  },
}));

// ─── Validation config per field ─────────────────────────────────────────────

const FIELD_RULES = {
  pickupOrganizationName:   { required: true  },
  pickupContactName:        { required: true  },
  pickupContactNumber:      { required: true, phone: true },
  pickupContactEmail:       { required: true, email: true },
  pickupStreetAddress1:     { required: true  },
  pickupStreetAddress2:     { required: true  },
  pickupCity:               { required: true  },
  pickupState:              { required: true  },
  pickupPostalCode:         { required: true  },
  pickupCountry:            { required: true  },
  siteUserName:             { required: true  },
  siteUserEmail:            { required: true, email: true },
  siteUserContact:          { required: true, phone: true },
  deliveryOrganizationName: { required: true  },
  deliveryContactName:      { required: true  },
  deliveryContactNumber:    { required: true, phone: true },
  deliveryContactEmail:     { required: true, email: true },
  deliveryStreetAddress1:   { required: true  },
  deliveryStreetAddress2:   { required: true  },
  deliveryCity:             { required: true  },
  deliveryState:            { required: false },
  deliveryPostalCode:       { required: true  },
  deliveryCountry:          { required: true  },
  expectedDeliveryDate:     { required: true  },
  specialInstructions:      { required: true  },
  freightForwarderUserName: { required: true  },
  freightForwarderContact:  { required: true, phone: true },
  freightForwarderEmail:    { required: true, email: true },
  billingCentreForShipment: { required: true  },
};

const SECTION_FIELDS = {
  pickup:   ['pickupOrganizationName','pickupContactName','pickupContactNumber','pickupContactEmail',
             'pickupStreetAddress1','pickupStreetAddress2','pickupCity','pickupState','pickupPostalCode','pickupCountry'],
  siteUser: ['siteUserName','siteUserEmail','siteUserContact'],
  delivery: ['deliveryOrganizationName','deliveryContactName','deliveryContactNumber','deliveryContactEmail',
             'deliveryStreetAddress1','deliveryStreetAddress2','deliveryCity','deliveryState','deliveryPostalCode',
             'deliveryCountry','expectedDeliveryDate','specialInstructions'],
  contact:  ['freightForwarderUserName','freightForwarderContact','freightForwarderEmail','billingCentreForShipment'],
};

function validateField(name, value) {
  const rules = FIELD_RULES[name];
  if (!rules) return '';
  const v = (value || '').trim();
  // For phone fields: PhoneInput returns the country dial code (e.g. "1") when blank — treat <7 digits as empty
  if (rules.phone) {
    const digits = v.replace(/\D/g, '');
    if (rules.required && digits.length < 7) return 'This field is required';
    if (digits.length >= 7 && digits.length < 7) return 'Enter a valid phone number';
    return '';
  }
  if (rules.required && !v) return 'This field is required';
  if (v && rules.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) return 'Enter a valid email address';
  return '';
}

// ─── One editable section — reads/writes a slice of formData ─────────────────
const Section = ({ title, editing, onEdit, onSave, onCancel, children }) => {
  const classes = useStyles();
  return (
    <>
      <Divider className={classes.divider} />
      <div className={classes.sectionWrap}>
        <div className={classes.sectionHeader}>
          <div>
            <Typography className={classes.inline}>{title}</Typography>
            <hr className={classes.hrLine} />
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            {onEdit && (
              <Button
                className={classes.editBtn}
                size="small"
                startIcon={
                  editing ? (
                    <SaveOutlinedIcon fontSize="small" />
                  ) : (
                    <EditOutlinedIcon fontSize="small" />
                  )
                }
                onClick={editing ? onSave : onEdit}
              >
                {editing ? "Save" : "Edit"}
              </Button>
            )}
            {editing && onCancel && (
              <Button
                className={classes.cancelBtn}
                size="small"
                onClick={onCancel}
              >
                Cancel
              </Button>
            )}
          </div>
        </div>
        {children}
      </div>
    </>
  );
};

// Read-only / editable field pair — shows validation error while editing
const FieldPair = ({ label, value, editing, name, onChange, error, isPhone }) => {
  const classes = useStyles();
  return (
    <Grid item xs={12} sm={6}>
      <Typography className={classes.fieldLabel}>{label}</Typography>
      {editing ? (
        isPhone ? (
          <div style={{ maxWidth: 280 }}>
            <PhoneInput
              country="us"
              value={value || ''}
              onChange={(phone) => onChange(name, phone)}
              enableSearch
              countryCodeEditable={false}
              specialLabel=""
              inputStyle={{
                width: '100%', height: '36px', fontSize: '0.85rem',
                borderColor: error ? '#f44336' : undefined,
              }}
              containerStyle={{ width: '100%' }}
              dropdownStyle={{ borderColor: '#0000008a' }}
              isValid={!error}
            />
            {error && (
              <Typography style={{ color: '#f44336', fontSize: '0.72rem', marginTop: 3 }}>
                {error}
              </Typography>
            )}
          </div>
        ) : (
          <TextField
            size="small"
            variant="outlined"
            value={value || ""}
            name={name}
            onChange={(e) => onChange(name, e.target.value)}
            error={!!error}
            helperText={error || ''}
            inputProps={{ style: { fontSize: "0.85rem", padding: "6px 10px" } }}
            style={{ maxWidth: 280, width: '100%' }}
          />
        )
      ) : (
        <Typography className={classes.fieldValue}>{value || "—"}</Typography>
      )}
    </Grid>
  );
};

const ShipmentScheduleIDForm = ({ open = true, onBack, row, batches: selectedBatchesProp = [] }) => {
  const classes = useStyles();
console.log("row",row);
  const pickFirst = (key) =>
    (selectedBatchesProp.find((b) => b[key] != null && b[key] !== '') || {})[key] || '';
  const initialDelivery = {
    deliveryOrganizationName: pickFirst('deliveryAddresseeOrgName'),
    deliveryStreetAddress1:   pickFirst('deliveryStreetAddress1'),
    deliveryStreetAddress2:   pickFirst('deliveryStreetAddress2'),
    deliveryCity:             pickFirst('deliveryCity'),
    deliveryState:            pickFirst('deliveryState'),
    deliveryPostalCode:       pickFirst('deliveryPostalCode'),
    deliveryCountry:          pickFirst('deliveryCountry'),
  };
  // confirmed/saved state — pre-seeded with batch delivery fields
  const [formData, setFormData] = useState(initialDelivery);
  // in-progress edit state (diverges from formData only while a section is being edited)
  const [draftData, setDraftData] = useState(initialDelivery);
  const [loading, setLoading] = useState(true);
  const [editing, setEditing] = useState({
    pickup: false,
    siteUser: false,
    delivery: false,
    contact: false,
    content: false,
  });
  // contentBatches: working copy with markForDelete flags (committed only on Save Changes)
  const [contentBatches, setContentBatches] = useState(selectedBatchesProp);
  const [savedContentBatches, setSavedContentBatches] = useState(selectedBatchesProp);
  const [showSuccess, setShowSuccess] = useState(false);
  const [shipmentIDs, setShipmentIDs] = useState(null);
  // XML viewer for the success pop-up: null | 'submission' | 'response'
  const [xmlView, setXmlView] = useState(null);
  const [xmlCopied, setXmlCopied] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errors, setErrors] = useState({});
  // file upload state
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [viewingFileID, setViewingFileID] = useState(null);
  const fileInputRef = useRef(null);
console.log("draftData",draftData);
console.log("formData",formData);
// console.log("BatchesList",batchesList);
  useEffect(() => {
    // Scoped demo: prefill every section from the "Shipment Schedule ID Form" tab
    // of 5_Viral Vector_Logistics.xlsx. Content Details (batch table) still comes
    // from the selected batches, and Attachments from the upload UI — both untouched.
    if (MOCK_SCHEDULE_FORM) {
      const merged = { ...MOCK_SCHEDULE_FORM_DATA };
      setFormData(merged);
      setDraftData(merged);
      setLoading(false);
      return;
    }

    const apiBase = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}`;

    const batchesPayload = selectedBatchesProp.map((b) => ({
      schrockenDeliveryScheduleBatchID: b.schrockenDeliveryScheduleBatchID,
    }));

    axios
      .post(`${apiBase}/fetchDataForShipmentIDGenerationForm`, {
        vendorMosymphonyID: row?.vendorMosymphonyID,
        aslNumber: row?.aslNumber,
        batchesList: batchesPayload,
      })
      .then((res) => {
        if (res.data.status) {
          const apiData = res.data.data || res.data;
          const firstVal = (key) =>
            (selectedBatchesProp.find((b) => b[key] != null && b[key] !== '') || {})[key] || '';
          const merged = {
            ...apiData,
            deliveryOrganizationName: firstVal('deliveryAddresseeOrgName'),
            deliveryStreetAddress1:   firstVal('deliveryStreetAddress1'),
            deliveryStreetAddress2:   firstVal('deliveryStreetAddress2'),
            deliveryCity:             firstVal('deliveryCity'),
            deliveryState:            firstVal('deliveryState'),
            deliveryPostalCode:       firstVal('deliveryPostalCode'),
            deliveryCountry:          firstVal('deliveryCountry'),
            // delivery contact fields come from the API response
            deliveryContactName:      apiData.deliveryContactName   || '',
            deliveryContactNumber:    apiData.deliveryContactNumber || '',
            deliveryContactEmail:     apiData.deliveryContactEmail  || '',
          };
          setFormData(merged);
          setDraftData(merged);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  }, []);
  const calcEDD = (pickupDate, duration) => {
    if (!pickupDate || duration == null) return '';
    const date = new Date(pickupDate);
    date.setDate(date.getDate() + Number(duration));
    const day   = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' }).toUpperCase();
    const year  = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const handleFieldChange = (name, value) => {
    setDraftData((prev) => {
      const updated = { ...prev, [name]: value };
      if (name === 'pickupDate' || name === 'pickupTime') {
        // Only auto-recompute EDD when a shipmentDuration is known (live backend).
        // In the Excel-scoped demo there is no duration, so keep the sheet's EDD as-is.
        if (formData.shipmentDuration != null) {
          const date = name === 'pickupDate' ? value : prev.pickupDate;
          updated.expectedDeliveryDate = calcEDD(date, formData.shipmentDuration);
        }
      }
      return updated;
    });
    setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
  };

  // Snapshot formData into draftData and clear section errors before editing
  const startEdit = (section) => {
    if (section === 'content') {
      // reset any pending deletions
      setContentBatches(savedContentBatches.map((b) => ({ ...b, markForDelete: false })));
      setEditing((p) => ({ ...p, content: true }));
      return;
    }
    setDraftData({ ...formData });
    setEditing((p) => ({ ...p, [section]: true }));
    const cleared = {};
    (SECTION_FIELDS[section] || []).forEach((f) => { cleared[f] = ''; });
    setErrors((prev) => ({ ...prev, ...cleared }));
  };

  // Validate all section fields, block save if any error exists
  const saveEdit = (section) => {
    if (section === 'content') {
      const remaining = contentBatches.filter((b) => !b.markForDelete);
      setSavedContentBatches(remaining);
      setEditing((p) => ({ ...p, content: false }));
      return;
    }
    const fields = SECTION_FIELDS[section] || [];
    const sectionErrors = {};
    let hasError = false;
    fields.forEach((name) => {
      const err = validateField(name, draftData[name]);
      sectionErrors[name] = err;
      if (err) hasError = true;
    });
    setErrors((prev) => ({ ...prev, ...sectionErrors }));
    if (hasError) return; // block save
    setFormData({ ...draftData });
    setEditing((p) => ({ ...p, [section]: false }));
  };

  // Discard draft, clear section errors
  const cancelEdit = (section) => {
    if (section === 'content') {
      setContentBatches(savedContentBatches.map((b) => ({ ...b, markForDelete: false })));
      setEditing((p) => ({ ...p, content: false }));
      return;
    }
    setDraftData({ ...formData });
    setEditing((p) => ({ ...p, [section]: false }));
    const cleared = {};
    (SECTION_FIELDS[section] || []).forEach((f) => { cleared[f] = ''; });
    setErrors((prev) => ({ ...prev, ...cleared }));
  };

  // Mark batch for deletion (committed only when Save Changes is clicked)
  const handleDelete = (schrockenDeliveryScheduleBatchID) => {
    setContentBatches((prev) =>
      prev.map((b) =>
        b.schrockenDeliveryScheduleBatchID === schrockenDeliveryScheduleBatchID
          ? { ...b, markForDelete: true }
          : b
      )
    );
  };

  const handleFileSelect = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (evt) => {
        setUploadedFiles((prev) => [
          ...prev,
          { name: file.name, data: evt.target.result, size: file.size },
        ]);
      };
      reader.readAsDataURL(file);
    });
    e.target.value = "";
  };

  const handleDownloadFile = (schrockenCustomFileID) => {
    const apiBase = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}`;
    axios
      .post(`${apiBase}/downloadCustomFile`, { schrockenCustomFileID })
      .then((res) => {
        if (res.data.status) {
          const byteArray = new Uint8Array(res.data.fileData.data);
          const a = window.document.createElement("a");
          a.href = window.URL.createObjectURL(
            new Blob([byteArray], { type: "application/octet-stream" })
          );
          a.download = res.data.fileName;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      })
      .catch((err) => console.log(err));
  };

  const currentXml = () => {
    if (xmlView === 'response') {
      // orderNumber in the response XML is the Freight Forwarder Schedule ID.
      return buildShipmentOrderResponseXml(shipmentIDs || {});
    }
    // "View Message Sent" — build the request XML live from the form page values.
    const mergedData = { ...formData, ...draftData };
    return buildShipmentOrderCreateXml(
      mergedData,
      savedContentBatches,
      shipmentIDs || {},
      { pickupDate: draftData.pickupDate, pickupTime: draftData.pickupTime }
    );
  };

  const openXmlView = (kind) => {
    setXmlCopied(false);
    setXmlView(kind);
  };

  const handleCopyXml = () => {
    const text = currentXml();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          setXmlCopied(true);
          setTimeout(() => setXmlCopied(false), 1500);
        })
        .catch(() => {});
    }
  };

  const toISODate = (val, time) => {
    if (!val) return null;
    const MONTHS = { JAN:'01',FEB:'02',MAR:'03',APR:'04',MAY:'05',JUN:'06',
                     JUL:'07',AUG:'08',SEP:'09',OCT:'10',NOV:'11',DEC:'12' };
    const t = time ? time.slice(0, 5) : '00:00';
    const m = String(val).match(/^(\d{2})-([A-Za-z]{3})-(\d{4})$/);
    if (m) return `${m[3]}-${MONTHS[m[2].toUpperCase()]}-${m[1]}T${t}`;
    // already YYYY-MM-DD
    if (/^\d{4}-\d{2}-\d{2}$/.test(val)) return `${val}T${t}`;
    return val;
  };

  const handleSubmit = () => {
    const apiBase = `${appUrl}/${localStorage.appName}/${localStorage.network}/${localStorage.collabType}/${localStorage.roleName}`;

    const poBatches = savedContentBatches.map((b) => [
      b.scheduleAgreementNumber,
      b.vendorBatchNumber,
    ]);

    const batchNumbers = savedContentBatches.map((b) => b.vendorBatchNumber);

    const netWeight = savedContentBatches.reduce(
      (sum, b) => sum + (Number(b.netWeight) || 0),
      0
    );

    const schrockenDeliveryScheduleBatchIDs = savedContentBatches.map(
      (b) => b.schrockenDeliveryScheduleBatchID
    );

    const requestPayload = {
      poBatches,
      batchNumbers,
      brandOwnerMosymphonyID: row?.brandOwnerMosymphonyID,
      vendorMosymphonyID: row?.vendorMosymphonyID,
      schrockenDeliveryScheduleBatchIDs,
      expectedDeliveryDate: toISODate(draftData.expectedDeliveryDate || formData.expectedDeliveryDate),
      scheduledPickupDate: toISODate(draftData.pickupDate, draftData.pickupTime),
      netWeight,
    };

    setSubmitLoading(true);
    // ── Dummy fetchShipmentIDs — simulate the backend generating the shipment
    // order numbers in the Freight Forwarder system. Succeeds after ~5.5s.
    // TODO: restore the real axios call below once the API is available.
    // const letters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    // const randLetters = (n) =>
    //   Array.from({ length: n }, () => letters[Math.floor(Math.random() * 26)]).join("");
    // const randDigits = (n) =>
    //   Array.from({ length: n }, () => Math.floor(Math.random() * 10)).join("");
    // setTimeout(() => {
    //   setShipmentIDs(
    //     MOCK_SCHEDULE_FORM
    //       ? { ...MOCK_SHIPMENT_IDS }
    //       : {
    //           // e.g. "OBH718-58L"
    //           sponsorShipmentID: `${randLetters(3)}${randDigits(3)}-${randDigits(2)}${randLetters(1)}`,
    //           // e.g. "IQF36483331"
    //           vendorShipmentID: `${randLetters(3)}${randDigits(8)}`,
    //           freightForwarderScheduleID: "3919519200",
    //         }
    //   );
    //   setShowSuccess(true);
    //   setSubmitLoading(false);
    // }, 5500);
    axios
      .post(`${apiBase}/fetchShipmentIDs`, requestPayload)
      .then((res) => {
        if (res.data.success) {
          setShipmentIDs(res.data.data);
          setShowSuccess(true);
          setSubmitLoading(false)
        } else {
          setShowError(true);
        }
      })
      .catch(() => setShowError(true))
      .finally(() => setSubmitLoading(false));
  };

  // ── Reusable section header with optional Edit/Save/Cancel ─────────────────
  const SectionHeader = ({ title, section }) => (
    <>
      <Divider className={classes.divider} />
      <Grid container justifyContent="space-between" alignItems="center" style={{ marginBottom: 12 }}>
        <Grid item>
          <Typography className={classes.inline}>{title}</Typography>
          <hr className={classes.hrLine} />
        </Grid>
        {section && (
          <Grid item style={{ display: 'flex', gap: 8 }}>
            {editing[section] ? (
              <>
                <Button
                  size="small"
                  onClick={() => cancelEdit(section)}
                  style={{
                    textTransform: 'none',
                    borderRadius: "15rem",
                    padding: '4px 14px',
                    fontSize: '0.78rem',
                    fontWeight: 600,
                    backgroundColor: '#fff',
                    color: '#000',
                    border: '1px solid #000',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#000'; e.currentTarget.style.color = '#fff'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#fff'; e.currentTarget.style.color = '#000'; }}
                >
                  Discard Changes
                </Button>
                <Button
                  size="small"
                  onClick={() => saveEdit(section)}
                  style={{
                    textTransform: 'none',
                    borderRadius: '15rem',
                    padding: '4px 14px',
                    fontSize: '0.78rem',
                    fontWeight: 600,
                    backgroundColor: '#ec6535',
                    color: '#fff',
                    border: '1px solid #ec6535',
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#c84e20'; e.currentTarget.style.borderColor = '#c84e20'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = '#ec6535'; e.currentTarget.style.borderColor = '#ec6535'; }}
                >
                  Save Changes
                </Button>
              </>
            ) : (
              <Button
                className={classes.editBtn}
                size="small"
                startIcon={<EditOutlinedIcon fontSize="small" />}
                onClick={() => startEdit(section)}
                disabled
              >
                Edit
              </Button>
            )}
          </Grid>
        )}
      </Grid>
    </>
  );

  return (
    <>
      {/* ── Main form dialog ─────────────────────────────────────────────────── */}
      <Dialog open={open} onClose={onBack} maxWidth="md" fullScreen>
        <DialogTitle disableTypography style={{ backgroundColor: '#F5F9FF', padding: '16px 24px', position: 'relative' }}>
          <Typography variant="h5" align="center" style={{ fontWeight: 'bold', marginTop: '1rem' }}>
            Shipment Schedule ID Generation Form
          </Typography>
          <Typography align="center">
            Pickup, Site User, Delivery, Content, Container and Contact Information Details
          </Typography>
          <Typography
            variant="body2"
            className={classes.closeBtn}
            onClick={onBack}
          >
            Cancel <CloseIcon style={{ fontSize: '35px', color: '#FF0000' }} />
          </Typography>
        </DialogTitle>

        <DialogContent>
          {loading ? (
            <Grid container justifyContent="center" alignItems="center" style={{ minHeight: 300}}>
              <CircularProgress/>
            </Grid>
          ) : (
            <div className={classes.content}>
              {/* ── Schedule Pickup ─────────────────────────────────────────── */}
             
              <Grid container spacing={0} style={{ marginBottom: 8 }}>
                <Grid item xs={12}>
                  <Typography className={classes.inline}>Schedule Pickup</Typography>
                  <hr className={classes.hrLine} />
                </Grid>
              </Grid>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Typography className={classes.fieldLabel}>Schedule Pickup Date</Typography>
                  <div style={{ position: 'relative', width: 200 }}>
                    {/* formatted label floats over the transparent date text */}
                    <Typography
                      className={classes.fieldValue}
                      style={{
                        position: 'absolute', top: '50%', transform: 'translateY(-50%)',
                        left: 10, pointerEvents: 'none', zIndex: 1,
                        color: draftData.pickupDate ? '#222' : '#aaa',
                      }}
                    >
                      {draftData.pickupDate ? formatDate(draftData.pickupDate) : 'DD-MMM-YYYY'}
                    </Typography>
                    <TextField
                      size="small"
                      type="date"
                      variant="outlined"
                      value={draftData.pickupDate || ''}
                      onChange={(e) => handleFieldChange('pickupDate', e.target.value)}
                      inputProps={{ style: { fontSize: '0.85rem', color: 'transparent' } }}
                      style={{ width: '100%' }}
                    />
                  </div>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Typography className={classes.fieldLabel}>Schedule Pickup Time</Typography>
                  <TextField
                    size="small" type="time" variant="outlined"
                    value={draftData.pickupTime || ''}
                    onChange={(e) => handleFieldChange('pickupTime', e.target.value)}
                    inputProps={{ style: { fontSize: '0.85rem' } }}
                    style={{ width: 180 }}
                  />
                </Grid>
              </Grid>

              {/* ── Pickup Details ──────────────────────────────────────────── */}
              <SectionHeader title="Pickup Details" section="pickup" />
              <Grid container spacing={2}>
                {[
                  ['Pickup Organization Name', 'pickupOrganizationName', false],
                  ['Pickup Contact Name', 'pickupContactName', false],
                  ['Pickup Contact Phone', 'pickupContactNumber', true],
                  ['Pickup Contact Email', 'pickupContactEmail', false],
                  ['Pickup Street Address 1', 'pickupStreetAddress1', false],
                  ['Pickup Street Address 2', 'pickupStreetAddress2', false],
                  ['Pickup City', 'pickupCity', false],
                  ['Pickup State', 'pickupState', false],
                  ['Pickup Post Code', 'pickupPostalCode', false],
                  ['Pickup Country', 'pickupCountry', false],
                ].map(([label, name, isPhone]) => (
                  <FieldPair key={name} label={label} value={draftData[name]}
                    editing={editing.pickup} name={name} onChange={handleFieldChange} error={errors[name]} isPhone={isPhone} />
                ))}
              </Grid>

              {/* ── Sponsor Point of Contact ────────────────────────────────── */}
              <SectionHeader title="Sponsor Point of Contact Details" section="siteUser" />
              <Grid container spacing={2}>
                {[
                  ['Site User Name', 'siteUserName', false],
                  ['Site User Email', 'siteUserEmail', false],
                  ['Site User Phone', 'siteUserContact', true],
                ].map(([label, name, isPhone]) => (
                  <FieldPair key={name} label={label} value={draftData[name]}
                    editing={editing.siteUser} name={name} onChange={handleFieldChange} error={errors[name]} isPhone={isPhone} />
                ))}
              </Grid>

              {/* ── Delivery Address Details ────────────────────────────────── */}
              <SectionHeader title="Delivery Address Details" section="delivery" />
              <Grid container spacing={2}>
                {[
                  ['Delivery Organization Name', 'deliveryOrganizationName', false],
                  ['Delivery Contact Name', 'deliveryContactName', false],
                  ['Delivery Contact Phone', 'deliveryContactNumber', true],
                  ['Delivery Contact Email', 'deliveryContactEmail', false],
                  ['Delivery Street Address 1', 'deliveryStreetAddress1', false],
                  ['Delivery Street Address 2', 'deliveryStreetAddress2', false],
                  ['Delivery City', 'deliveryCity', false],
                  ['Delivery State', 'deliveryState', false],
                  ['Delivery Post Code', 'deliveryPostalCode', false],
                  ['Delivery Country', 'deliveryCountry', false],
                  ['Expected Delivery Date', 'expectedDeliveryDate', false],
                  ['Special Instructions', 'specialInstructions', false],
                ].map(([label, name, isPhone]) => (
                  <FieldPair key={name} label={label} value={draftData[name]}
                    editing={editing.delivery} name={name} onChange={handleFieldChange} error={errors[name]} isPhone={isPhone} />
                ))}
              </Grid>

              {/* ── Content Details ─────────────────────────────────────────── */}
              <SectionHeader title="Content Details" section="content" />
              <Grid container spacing={0}>
                <Grid item xs={12} style={{ overflowX: 'auto' }}>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        {editing.content && (
                          <TableCell className={classes.tableHeadCell} style={{ width: 40, padding: '8px 6px' }} />
                        )}
                        {['FG Batch Number', 'BMS Product Code / Description', 'Quantity',
                          'No. of Pallets', 'Net Weight', 'Gross Weight', 'UoM', 'Temperature'].map((h) => (
                          <TableCell key={h} className={classes.tableHeadCell}>{h}</TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {(editing.content
                        ? contentBatches.filter((b) => !b.markForDelete)
                        : savedContentBatches
                      ).length > 0
                        ? (editing.content ? contentBatches.filter((b) => !b.markForDelete) : savedContentBatches).map((b) => (
                          <TableRow key={b.schrockenDeliveryScheduleBatchID || b.vendorBatchNumber}>
                            {editing.content && (
                              <TableCell className={classes.tableBodyCell} style={{ padding: '4px 6px', width: 40 }}>
                                <IconButton
                                  size="small"
                                  onClick={() => handleDelete(b.schrockenDeliveryScheduleBatchID)}
                                  style={{ color: '#e53935' }}
                                >
                                  <DeleteIcon fontSize="small" />
                                </IconButton>
                              </TableCell>
                            )}
                            <TableCell className={classes.tableBodyCell}>{b.vendorBatchNumber}</TableCell>
                            <TableCell className={classes.tableBodyCell}>{b.fgMaterialCode} / {b.fgMaterialName}</TableCell>
                            <TableCell className={classes.tableBodyCell}>{b.readyForDispatchQuantity ?? '—'}</TableCell>
                            <TableCell className={classes.tableBodyCell}>{b.noOfPallets ?? '—'}</TableCell>
                            <TableCell className={classes.tableBodyCell}>{b.netWeight ?? '—'}</TableCell>
                            <TableCell className={classes.tableBodyCell}>{b.grossWeight ?? '—'}</TableCell>
                            <TableCell className={classes.tableBodyCell}>{b.batchUOM ?? '—'}</TableCell>
                            <TableCell className={classes.tableBodyCell}>{b.temperature ?? '—'}</TableCell>
                          </TableRow>
                        ))
                        : (
                          <TableRow>
                            <TableCell colSpan={editing.content ? 9 : 8} align="center" style={{ padding: 24, color: '#9E9E9E' }}>
                              No batches available
                            </TableCell>
                          </TableRow>
                        )
                      }
                    </TableBody>
                  </Table>
                </Grid>
              </Grid>

              {/* ── Contact Information for Shipment ────────────────────────── */}
              <SectionHeader title="Contact Information for Shipment" section="contact" />
              <Grid container spacing={2}>
                {[
                  ['Contact Person', 'freightForwarderUserName', false],
                  ['Contact Number', 'freightForwarderContact', true],
                  ['Billing Center for Shipment', 'billingCentreForShipment', false],
                  ['Email Notification', 'freightForwarderEmail', false],
                ].map(([label, name, isPhone]) => (
                  <FieldPair key={name} label={label} value={draftData[name]}
                    editing={editing.contact} name={name} onChange={handleFieldChange} error={errors[name]} isPhone={isPhone} />
                ))}
              </Grid>

              {/* ── Attachments ─────────────────────────────────────────────── */}
              <SectionHeader title="Attachments" section={null} />
              <Grid container spacing={1}>
                {Array.isArray(formData.packingListFileDetails) && formData.packingListFileDetails.map((file, idx) => (
                  <Grid item xs={12} key={idx}>
                    <Typography
                      className={classes.downloadLink}
                      onClick={() => setViewingFileID(file.schrockenCustomFileID)}
                    >
                      <GetAppIcon style={{color:"#2196f3"}} fontSize="small" />
                      {file.customFileName || `Packing List ${idx + 1}`}
                    </Typography>
                  </Grid>
                ))}
                {uploadedFiles.map((f, idx) => (
                  <Grid item xs={12} key={idx}>
                    <Typography className={classes.downloadLink}>
                      <GetAppIcon style={{color:"#2196f3"}} fontSize="small" /> {f.name}
                    </Typography>
                  </Grid>
                ))}
                <Grid item xs={12}>
                  <input
                    ref={fileInputRef} type="file"
                    accept=".pdf,.jpeg,.png,.jpg,.bmp,.doc,.docx,.xls,.xlsx,.csv"
                    multiple style={{ display: 'none' }} onChange={handleFileSelect}
                  />
                  <div
                    className={classes.uploadBox}
                    onClick={() => fileInputRef.current && fileInputRef.current.click()}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <div style={{ width: 24 }} />
                      <Typography variant="body2" style={{ flex: 1, textAlign: 'center', color: '#000', fontSize: '0.85rem' }}>
                        Drag &amp; drop file or click here to upload files
                      </Typography>
                      <GetAppIcon style={{ fontSize: 24, color: '#000' }}/>
                      {/* <PublishIcon style={{ fontSize: 24, color: '#000' }} /> */}
                    </div>
                  </div>
                </Grid>
              </Grid>
              <Button
                variant="contained"
                disableElevation
                className={classes.submitBtn}
                onClick={handleSubmit}
                disabled={submitLoading || !draftData.pickupDate || !draftData.pickupTime}
              >
                Submit to Logistics Portal
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* File viewer */}
      {viewingFileID && (
        <FileViewer
          schrockenCustomFileID={viewingFileID}
          openFileView={true}
          handleFileViewClose={() => setViewingFileID(null)}
          downloadFile={handleDownloadFile}
        />
      )}

      {/* Success dialog */}
      <Dialog
        open={showSuccess}
        onClose={() => { setShowSuccess(false); onBack && onBack(); }}
        maxWidth="sm" fullWidth
      >
        <DialogContent style={{ padding: '40px 32px 24px' }}>
          <CheckCircleIcon className={classes.successIcon} />
          <Typography className={classes.successText}>
            Shipment Order Numbers Generated in<br />Freight Forwarder System
          </Typography>
          <div style={{ marginTop: 25 }}>
            <Grid container spacing={2}>
              {[
                ['Sponsor', shipmentIDs?.sponsorShipmentID],
                ['CMO', shipmentIDs?.vendorShipmentID],
                ['Freight Forwarder', shipmentIDs?.freightForwarderScheduleID],
              ].map(([label, val]) => (
                <Grid item xs={4} key={label}>
                  <Typography style={{ color: '#000', fontSize: '0.9rem', fontWeight: 600,whiteSpace:"nowrap" }}>{label}</Typography>
                  <Typography style={{ fontSize: '0.88rem', color: '#333' }}>{val}</Typography>
                </Grid>
              ))}
            </Grid>
          </div>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: 20, marginTop: 5, gap: 10 }}>
          <Button
            variant="outlined"
            disableElevation
            className={classes.xmlActionBtn}
            onClick={() => openXmlView('submission')}
          >
            View Message Sent
          </Button>
          <Button
            variant="contained" disableElevation
            style={{ backgroundColor: ORANGE, color: '#fff', borderRadius: 20, textTransform: 'none', padding: '6px 32px' }}
            onClick={() => { setShowSuccess(false); onBack && onBack(); }}
          >
            Ok
          </Button>
          <Button
            variant="outlined"
            disableElevation
            className={classes.xmlActionBtn}
            onClick={() => openXmlView('response')}
          >
            View Response
          </Button>
        </DialogActions>
      </Dialog>

      {/* XML viewer dialog — shows the Shipment Order Create / Response payloads */}
      <Dialog open={!!xmlView} onClose={() => setXmlView(null)} maxWidth="md" fullWidth>
        <DialogTitle disableTypography className={classes.xmlDialogTitle}>
          <div>
            <Typography style={{ fontWeight: 700, fontSize: '1.05rem' }}>
              {xmlView === 'response' ? 'XML For Response' : 'XML For Submission'}
            </Typography>
            <Typography style={{ fontSize: '0.78rem', color: '#777' }}>
              {xmlView === 'response' ? 'Shipment_Order_Response' : 'Shipment_Order_Create'}
            </Typography>
          </div>
          <IconButton size="small" onClick={() => setXmlView(null)}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ padding: 0 }}>
          <pre className={classes.xmlPre}>{xmlView ? currentXml() : ''}</pre>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'flex-end', padding: '10px 20px', borderTop: '1px solid #E0E0E0' }}>
          <Button
            onClick={handleCopyXml}
            startIcon={<FileCopyOutlinedIcon fontSize="small" />}
            style={{ textTransform: 'none', color: NAVY, fontWeight: 600 }}
          >
            {xmlCopied ? 'Copied!' : 'Copy XML'}
          </Button>
          <Button
            variant="contained" disableElevation
            style={{ backgroundColor: ORANGE, color: '#fff', borderRadius: 20, textTransform: 'none', padding: '6px 28px' }}
            onClick={() => setXmlView(null)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop loading */}
      <Backdrop open={submitLoading} style={{ zIndex: 1400 }}>
        <CircularProgress style={{ color: ORANGE }} />
      </Backdrop>

      {/* Error dialog */}
      <Dialog open={showError} onClose={() => setShowError(false)} maxWidth="xs" fullWidth>
        <DialogContent style={{ padding: '32px 24px', textAlign: 'center' }}>
          <Typography style={{ color: '#FF0000', fontWeight:900, fontSize: '1.4rem' }}>
            Something went wrong
          </Typography>
          <Typography style={{ color: '#000', fontSize: '0.88rem', marginTop: 8 }}>
            Failed to fetch shipment IDs. Please try again.
          </Typography>
        </DialogContent>
        <DialogActions style={{ justifyContent: 'center', paddingBottom: 20 }}>
          <Button
            variant="contained"
            disableElevation
            style={{ backgroundColor: ORANGE, color: '#fff', borderRadius: 20, textTransform: 'none', padding: '6px 32px' }}
            onClick={() => setShowError(false)}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShipmentScheduleIDForm;
